<section #section (scroll)="onScroll()">
  <div class="header-content">
    @if (backLink) {
      <mr-go-back-link [link]="backLink">
        {{ backLinkLabel || "Go Back" }}
      </mr-go-back-link>
    }

    <ng-content select="[pagePreHeader]"></ng-content>

    <header
      [class.with-subheader]="subHeader || subHeaderTemplate"
      [class.with-underline]="showHeaderUnderline"
    >
      <div class="page-title-wrapper">
        @if (superHeader) {
          <p class="super-header">
            {{ superHeader }}
          </p>
        }

        <div class="header">
          <h1>
            @if (!headerTemplate) {
              {{ header }}
            } @else {
              <ng-template [ngTemplateOutlet]="headerTemplate!"></ng-template>
            }
          </h1>

          <div class="header-suffix">
            <ng-content select="[pageHeaderSuffix]"></ng-content>
          </div>
        </div>

        @if (subHeader || subHeaderTemplate) {
          <h2>
            @if (!subHeaderTemplate) {
              {{ subHeader }}
            } @else {
              <ng-template
                [ngTemplateOutlet]="subHeaderTemplate!"
              ></ng-template>
            }
          </h2>
        }
      </div>

      <div class="page-header-actions">
        <ng-content select="[pageHeaderAction]"></ng-content>
      </div>
    </header>

    @if (headerDetails) {
      <div class="header-details">
        <ng-container *ngTemplateOutlet="headerDetails"></ng-container>
      </div>
    }

    <ng-content select="mr-tab-list"></ng-content>

    @if (!hideSeparator) {
      <hr />
    }
  </div>

  <ng-content></ng-content>
</section>

<ng-content select="mr-sidebar"></ng-content>

<ng-container
  *mrIfHasPermission="
    Permission.CreateHelpAssistTicket;
    operator: 'and';
    condition: helpButtonTemplate;
    else: defaultHelpButtonTemplate
  "
  [ngTemplateOutlet]="helpButtonTemplate"
></ng-container>

<ng-template #defaultHelpButtonTemplate>
  <mr-help-button></mr-help-button>
</ng-template>

<mr-environment-visual-aid></mr-environment-visual-aid>
